import { render, staticRenderFns } from "./contactWay.vue?vue&type=template&id=468162dc"
import script from "./contactWay.vue?vue&type=script&lang=js"
export * from "./contactWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468162dc')) {
      api.createRecord('468162dc', component.options)
    } else {
      api.reload('468162dc', component.options)
    }
    module.hot.accept("./contactWay.vue?vue&type=template&id=468162dc", function () {
      api.rerender('468162dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/settings/components/contactWay.vue"
export default component.exports